<div mat-dialog-title>
  {{ data.title }}
</div>

<mat-dialog-content>
  <form [formGroup]="formGroup">
    <mat-form-field fxFlex>
      <mat-label>{{ 'date-picker-dialog.select-date' | translate }}</mat-label>
      <input matInput [matDatepicker]="picker" [min]="min" formControlName="date">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
  >
    {{ 'common.cancel' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    type="submit"
    [disabled]="formGroup.invalid"
    (click)="onSubmit()"
  >
    {{ 'common.save' | translate }}
  </button>
</mat-dialog-actions>
